import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';

export interface routeJumpState {
  url: string;
  status: boolean;
}

export const ROUTEJUMP_KEY = 'React-ts-ant-routeJump';

const localRouteJump = LocalStore.getValue<routeJumpState>(ROUTEJUMP_KEY) || {};

export const defaults: routeJumpState = {
  url: '',
  status: false,
  ...localRouteJump
};

const ROUTE_JUMP_KEY = 'React-ts-ant-ROUTEJUMP';

export const updateRouteJump: (routeJump: routeJumpState) => IAction<routeJumpState> = (routeJump: routeJumpState) => ({
  type: ROUTE_JUMP_KEY,
  payload: routeJump
});

const routeJumpReducer: Reducer<routeJumpState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case ROUTE_JUMP_KEY:
      LocalStore.setValue(ROUTEJUMP_KEY, payload as routeJumpState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default routeJumpReducer;
